import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { cmsAPI } from '../../utilities/api/cmsApi';
import { CmsItem } from '../../utilities/interfaces/CmsItem';

// represents the shape of the slice in state
interface CmsState {
  cmsItems: CmsItem[];
  error: string | null;
}

const initialState: CmsState = {
  cmsItems: [],
  error: null,
};

const cmsSlice = createSlice({
  name: 'publicCms',
  initialState,
  reducers: {
    // add new cms item
    addCmsItem(state, action: PayloadAction<any>) {
      // its okay to do this because immer makes it immutable
      state.cmsItems.push(action.payload);
    },
  },
  extraReducers(builder) {
    builder.addCase(getAllPublicCms.fulfilled, (state, action: any) => {
      state.cmsItems = action.payload;
    });
    builder.addCase(updateCmsItem.fulfilled, (state, action: any) => {
      // find cms item in redux store and update
      var id = action.meta.arg.id;
      var text = action.meta.arg.cmsItemValue;
      var index = state.cmsItems.findIndex((cmsData) => cmsData.id === id);
      state.cmsItems[index].cmsItemValue = text;
    });
  },
});

// Thunks for any async data dealing with the api
export const getAllPublicCms = createAsyncThunk('publicCms/getAllPublicCms', async () => {
  const response = await cmsAPI.getCmsItems();
  return response;
});

export const updateCmsItem = createAsyncThunk(
  'publicCms/updateCmsItem',
  async (cmsItem: CmsItem) => {
    const response = await cmsAPI.updateCmsItem(cmsItem);
    return response;
  }
);

export const { addCmsItem } = cmsSlice.actions;
export default cmsSlice.reducer;
